import { features as siteFeatures } from "../data/features";
import { useStudio } from "../studio/StudioContext";

const MONTHS = new Set([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]);

/** Year-first for dated items; leave ranges / freeform strings alone. */
const formatFeatureDate = (date) => {
  const raw = String(date || "").trim();
  const parts = raw.split(/\s+/);

  // "10 Jul 2026" → "2026 Jul 10"
  if (
    parts.length === 3 &&
    /^\d{1,2}$/.test(parts[0]) &&
    MONTHS.has(parts[1]) &&
    /^\d{4}$/.test(parts[2])
  ) {
    return `${parts[2]} ${parts[1]} ${parts[0]}:`;
  }

  // "Jul 2026" → "2026 Jul"
  if (
    parts.length === 2 &&
    MONTHS.has(parts[0]) &&
    /^\d{4}$/.test(parts[1])
  ) {
    return `${parts[1]} ${parts[0]}:`;
  }

  return `${raw}:`;
};

const Features = ({ items: itemsProp } = {}) => {
  const { studioMode, draft } = useStudio();
  // Only overlay draft while Visual edit is open — otherwise a stale
  // localStorage draft silently overrides src/data/features.js.
  const features =
    itemsProp ||
    (studioMode && draft?.features) ||
    siteFeatures;

  return (
    <div className="flex flex-col gap-3 pb-3">
      <ul className="list-disc space-y-1 pl-4 pr-2 text-sm leading-relaxed text-gray-700 dark:text-gray-300 custom-scrollbar">
        {features.map((item, idx) => (
          <li key={idx}>
            <span className="font-semibold text-gray-700 dark:text-gray-300">
              {formatFeatureDate(item.date)}
            </span>{" "}
            <span
              className="[&>a]:break-words"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            {item.description && (
              <>
                {" - "}
                <span
                  className="[&>a]:break-words"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Features;
